import { Maybe } from '@passionware/monads';
import Color from 'color';
import React, { ComponentProps } from 'react';
import { cn } from 'v5/platform/dom/cn';

export interface ColorDotProps extends Omit<ComponentProps<'div'>, 'color'> {
  color: Maybe<string>;
}

// Stored colours (e.g. legacy groups) can be empty or not parseable.
function parseColor(color: Maybe<string>) {
  const value = color?.trim();
  if (!value) return undefined;
  try {
    return Color(value);
  } catch {
    return undefined;
  }
}

export const ColorDot = ({
  color,
  className,
  style,
  ...props
}: ColorDotProps) => {
  const parsed = parseColor(color);
  const background = parsed ?? Color('white');
  return (
    <div
      className={cn('rounded-full shrink-0 size-3 border', className)}
      style={{
        backgroundColor: parsed ? color!.trim() : 'white',
        borderColor:
          background.contrast(Color('white')) < 2
            ? 'rgba(0, 0, 0, 0.2)'
            : 'transparent',
        ...style
      }}
      {...props}
    />
  );
};
